/*
 * @Date: 2019-10-08 11:21:21
 * @LastEditors  : guantingting
 * @LastEditTime : 2019-12-19 11:21:29
 */
export default {
  vorderDetail: {},
  tagList: [],
  newComment: {
    score: 10,
    score1: 10,
    specialty: 10,
    effect: 10,
    orderId: '',
    spuId: '',
    content: '',
    imageUrls: '',
    tags: ''
  },
  commentDigest: {},
  shareCommentWorker: {},
  shareComment: {},
  shareKey: '', // 获取分享ky
  commentSettings: {},
  commentObj: {
    // 对人的评价
    object_id: '',
    source: 'H5',
    content: '',
    score: 10,
    // score1: 0,
    // score2: 0,
    // score3: 0,
    image_urls: '',
    tags: ''
  }
}
